module.exports = __webpack_public_path__ + "img/cirrus.310ea8bd.png";